var _path, _path2, _path3, _rect, _rect2, _rect3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var Svg3Dodont = function Svg3Dodont(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 13,
    viewBox: "0 0 34 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43759 1.8393L2.39185 4.85724L0.600006 3.03518L1.2417 2.40412L2.4001 3.58206L4.80412 1.2L5.43759 1.8393Z",
    fill: "#00A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4376 1.8393L14.3918 4.85724L12.6 3.03518L13.2417 2.40412L14.4001 3.58206L16.8041 1.2L17.4376 1.8393Z",
    fill: "#00A88E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5303 3L28.7501 1.78024L28.2198 1.24991L27 2.46967L25.7802 1.24991L25.2499 1.78024L26.4697 3L25.2499 4.21976L25.7802 4.75009L27 3.53033L28.2198 4.75009L28.7501 4.21976L27.5303 3Z",
    fill: "#FF3748"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 10,
    height: 7,
    fill: "#DBE5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 10,
    height: 7,
    fill: "#DBE5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 10,
    height: 7,
    fill: "#DBE5E5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3Dodont, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3do&dont.2059fa89.svg";
export { ForwardRef as ReactComponent };